module.exports = __webpack_public_path__ + "img/arrow.7805f7b6.svg";